<template>
    <div class="historyPayIn">
        <HistoryAddress/>
    </div>
</template>

<script>
import HistoryAddress from "../components/elements/history-addresses/HistoryAddress";

export default {
    name: "historyPayIn",

    components: {
        HistoryAddress,
    },
};
</script>

<style scoped lang="scss">

</style>